/**
 * Higieniza uma lista de campos genéricos (header/footer/capa) vinda da API.
 *
 * Em 27/07/2026 uma company apareceu com `documentConfig.defaultHeader = [[], [], [], []]`
 * e o app não conseguia mais desserializar a company — o cliente não logava.
 *
 * A web tem um papel específico nesse ciclo: os editores semeiam o estado com
 * `{ ...item }`, e o spread de um array vira `{}`. Ou seja, ao abrir e salvar o editor
 * sobre um dado corrompido, a web devolve itens vazios e o problema se perpetua. Filtrar
 * na leitura corta esse caminho (a API também descarta na escrita).
 *
 * Descarta o que não for objeto simples e objetos sem `fieldId`, sem `type` e sem `value`.
 * O `value` entra no critério por causa da capa, onde um item legítimo pode chegar com
 * `fieldId` vazio.
 */
export function sanitizeGenericFields<T>(fields: T[] | null | undefined): T[] {
    if (!Array.isArray(fields)) return [];

    return fields.filter(field => {
        if (!field || typeof field !== 'object' || Array.isArray(field)) return false;

        const { fieldId, type, value } = field as {
            fieldId?: unknown;
            type?: unknown;
            value?: unknown;
        };

        return Boolean(fieldId) || Boolean(type) || (value !== undefined && value !== null);
    });
}
